import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Status } from "../../common/constants";
import { sendDasAlertUrl } from "../../config";
import { RootState } from "../../store";
import api from '../../api';
import { IInitialSliceState } from "../../common/types/commonTypes";

const CREATE_DAS_ALERT = "sendDasAlerta"

const initialState: IInitialSliceState = {
    status: null,
    error: null,
    reqId: null,
    msg: null
};

interface ICreateAlertResponse {
    message: string;
}

interface IDasAlertPayload {
    selectedGroups: {
        id: string;
        displayName: string;
    }[];
}


export const sendDasAlert = createAsyncThunk(
    CREATE_DAS_ALERT,
    async (payload: IDasAlertPayload | undefined, { rejectWithValue }) => {
        try {
            const response = await api.post<ICreateAlertResponse>(sendDasAlertUrl, payload);
            const alertsData: ICreateAlertResponse = response.data;
            return alertsData;
        } catch (error:any) {
           const data = error.response?.data || {};
            let errorMessage = "Failed to send DAS Alert";

            if (data.message) {
                errorMessage = data.message;
            }
            else if (typeof data === 'string') {
                errorMessage = data;
            }
            else if (error.message) {
                errorMessage = error.message;
            }

            return rejectWithValue(errorMessage);        
        }
    }
);

const dasAlertSlice = createSlice({
    name: CREATE_DAS_ALERT,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(sendDasAlert.pending, (state) => {
                state.status = Status.PENDING;
                state.msg = null;
            })
            .addCase(sendDasAlert.fulfilled, (state, action) => {
                state.msg = action.payload.message;
                state.reqId = Math.random();
                state.status = Status.SUCCESS;
            })
            .addCase(sendDasAlert.rejected, (state, action) => {
                state.msg = (action.payload as string) || "Failed to send DAS Alert";
                
                state.reqId = Math.random();
                state.status = Status.FAILED;
            });
    },
});

export const selector = (state: RootState) => state.sendDasAlert;

export const reducer = dasAlertSlice.reducer;

